(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rf-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var qtyByVariant = {};
    var msgTimer = null;

    function post(path, body) {
      return fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-RF-Card': '1' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) {
          if (!res.ok) throw json;
          return json;
        });
      });
    }

    function getCart() {
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); });
    }

    function readCart(cart) {
      qtyByVariant = {};
      cart.items.forEach(function (item) { qtyByVariant[item.variant_id] = item.quantity; });
    }

    // Show "Add" or the - 1 + stepper on every card, based on what's in the cart.
    function paint() {
      document.querySelectorAll('[data-rf-buy]').forEach(function (buy) {
        var qty = qtyByVariant[buy.getAttribute('data-variant-id')] || 0;
        buy.querySelector('[data-rf-qty]').textContent = qty;
        buy.querySelector('.rf-card__form').hidden = qty > 0;
        buy.querySelector('[data-rf-stepper]').hidden = qty === 0;
      });
      // "x2" on each size chip that is in the cart
      document.querySelectorAll('[data-rf-chip]').forEach(function (chip) {
        var q = qtyByVariant[chip.getAttribute('data-variant-id')] || 0;
        chip.querySelector('[data-rf-chip-qty]').textContent = q > 0 ? '\u00d7' + q : '';
      });
    }

    // choose a size: swap price, size label and the variant the buttons act on
    document.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-rf-chip]');
      if (!chip || chip.disabled) return;
      var card = chip.closest('.rf-card');
      var buy = card.querySelector('[data-rf-buy]');
      if (!buy) return;
      card.querySelectorAll('[data-rf-chip]').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var id = chip.getAttribute('data-variant-id');
      buy.setAttribute('data-variant-id', id);
      var input = buy.querySelector('[data-rf-id]');
      if (input) input.value = id;
      var price = card.querySelector('[data-rf-price]');
      if (price) price.textContent = chip.getAttribute('data-price');
      var size = card.querySelector('[data-rf-size]');
      if (size) size.textContent = chip.getAttribute('data-size');
      paint();
    });

    // Re-render the theme's cart UI (header count + slide-in cart) with
    // Shopify's Section Rendering API (opening the drawer is a separate step, see openCartDrawer).
    //  - header count: the element with id="cart-icon-bubble" (Dawn-style themes)
    //  - slide-in cart: the theme section that contains the cart drawer element
    // On themes that don't match, listen for the 'rf:cart:updated' event below.
    function parse(html) {
      return new DOMParser().parseFromString(html, 'text/html');
    }

    function refreshCartUI(cart) {
      var bubble = document.getElementById('cart-icon-bubble');

      // Dawn-style drawer: <cart-drawer> containing <div id="CartDrawer">.
      // The theme re-renders it from the 'cart-drawer' section.
      var dawnDrawer = document.querySelector('cart-drawer');
      var dawnInner = dawnDrawer && dawnDrawer.querySelector('#CartDrawer');

      // Fallback: a drawer that lives inside its own theme section wrapper.
      var drawerWrap = null;
      var drawerId = null;
      if (!dawnInner) {
        var other = document.querySelector('cart-drawer-component, #cart-drawer, .cart-drawer');
        drawerWrap = other && other.closest('.shopify-section');
        // skip if the drawer lives inside the header section (re-rendering that is too heavy)
        if (drawerWrap && drawerWrap.id && !drawerWrap.querySelector('header')) {
          drawerId = drawerWrap.id.replace(/^shopify-section-/, '');
        }
      }

      var ids = [];
      if (bubble) ids.push('cart-icon-bubble');
      if (dawnInner) ids.push('cart-drawer');
      if (drawerId) ids.push(drawerId);
      if (!ids.length) return Promise.resolve();

      return fetch(root + '?sections=' + ids.join(','))
        .then(function (res) { return res.json(); })
        .then(function (sections) {
          if (bubble && sections['cart-icon-bubble']) {
            var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
            if (b) bubble.innerHTML = b.innerHTML;
          }

          if (dawnInner && sections['cart-drawer']) {
            var freshInner = parse(sections['cart-drawer']).querySelector('#CartDrawer');
            if (freshInner) {
              dawnInner.innerHTML = freshInner.innerHTML;
              dawnDrawer.classList.toggle('is-empty', !cart || cart.item_count === 0);
              // the overlay element was replaced, so re-attach "click to close"
              var overlay = dawnDrawer.querySelector('#CartDrawer-Overlay');
              if (overlay && typeof dawnDrawer.close === 'function') {
                overlay.addEventListener('click', dawnDrawer.close.bind(dawnDrawer));
              }
            }
          }

          if (drawerId && drawerWrap && sections[drawerId]) {
            var d = parse(sections[drawerId]).querySelector('.shopify-section');
            if (d) drawerWrap.innerHTML = d.innerHTML;
          }
        })
        .catch(function () {});
    }

    // Slide the cart open after an item is added (not after a "-" or an error).
    // Dawn-style themes: <cart-drawer> has an open() method. Other themes: listen for 'rf:cart:open'
    // or fall back to clicking the header cart icon when a drawer element exists on the page.
    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
      var opened = !document.dispatchEvent(new CustomEvent('rf:cart:open', { cancelable: true }));
      if (opened) return;
      var hasDrawer = document.querySelector('cart-drawer, cart-drawer-component, #cart-drawer, .cart-drawer');
      var icon = document.getElementById('cart-icon-bubble');
      if (hasDrawer && icon) icon.click();
    }

    function applyCart(cart, openAfter) {
      readCart(cart);
      paint();
      document.dispatchEvent(new CustomEvent('rf:cart:updated', { detail: { cart: cart } }));
      return refreshCartUI(cart).then(function () {
        if (openAfter) openCartDrawer();
      });
    }

    // Errors (for example "The maximum quantity of this item is already in your cart.") show as a toast
    // near the top of the page instead of inside the card.
    var toastEl = null;
    function ensureToast() {
      if (toastEl && document.body.contains(toastEl)) return toastEl;
      toastEl = document.createElement('div');
      toastEl.className = 'rf-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      toastEl.addEventListener('click', function () { toastEl.classList.remove('is-on'); });
      document.body.appendChild(toastEl);
      return toastEl;
    }

    function showMessage(buy, text) {
      if (!text) return;
      var el = ensureToast();
      el.textContent = text;
      el.classList.remove('is-on');
      void el.offsetWidth; // restart the fade-in if a toast is already showing
      el.classList.add('is-on');
      clearTimeout(msgTimer);
      msgTimer = setTimeout(function () { el.classList.remove('is-on'); }, 4500);
    }

    function run(buy, request, openAfter) {
      if (buy.classList.contains('is-busy')) return;
      buy.classList.add('is-busy');
      request
        .then(function (cart) { return applyCart(cart, openAfter); })
        .catch(function (err) {
          showMessage(buy, (err && (err.description || err.message)) || 'Could not update your cart.');
        })
        .then(function () { buy.classList.remove('is-busy'); });
    }

    function addOne(buy) {
      var id = Number(buy.getAttribute('data-variant-id'));
      return post('cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(getCart);
    }

    // first "Add" click (progressive enhancement over the normal form post)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.rf-card__form');
      if (!form) return;
      var buy = form.closest('[data-rf-buy]');
      if (!buy) return;
      e.preventDefault();
      run(buy, addOne(buy), true);
    });

    document.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-rf-inc]');
      var dec = e.target.closest('[data-rf-dec]');
      if (!inc && !dec) return;
      var buy = (inc || dec).closest('[data-rf-buy]');
      if (!buy) return;
      if (inc) {
        run(buy, addOne(buy), true);
      } else {
        var id = Number(buy.getAttribute('data-variant-id'));
        var next = Math.max(0, (qtyByVariant[id] || 0) - 1);
        // change.js wants the id as a string (a JSON number is rejected)
        run(buy, post('cart/change.js', { id: String(id), quantity: next }));
      }
    });

    // taste profile square: tap to show its name on touch screens, tap elsewhere to close
    document.addEventListener('click', function (e) {
      var tp = e.target.closest && e.target.closest('[data-rf-tp]');
      document.querySelectorAll('[data-rf-tp].is-open').forEach(function (el) { if (el !== tp) el.classList.remove('is-open'); });
      if (tp) tp.classList.toggle('is-open');
    });

    function init() { ensureToast(); getCart().then(function (cart) { readCart(cart); paint(); }); }

    // Keep the cards in sync when the cart changes somewhere else (the slide-in cart,
    // the cart page, another script): re-read the cart after any cart write request.
    // Our own requests are marked with an X-RF-Card header and skipped (applyCart handles them).
    if (!window.__rfCardCartWatch) {
      window.__rfCardCartWatch = true;
      var syncTimer = null;
      var origFetch = window.fetch;
      window.fetch = function (input, init2) {
        var promise = origFetch.apply(this, arguments);
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var hdrs = (init2 && init2.headers) || (input && input.headers) || {};
          var mine = typeof hdrs.get === 'function' ? hdrs.get('X-RF-Card') : hdrs['X-RF-Card'];
          if (!mine && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            promise.then(function () {
              clearTimeout(syncTimer);
              syncTimer = setTimeout(init, 200);
            }, function () {});
          }
        } catch (err) {}
        return promise;
      };
      // Dawn also announces cart changes on its own event bus when it has one
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          clearTimeout(syncTimer);
          syncTimer = setTimeout(init, 200);
        });
      }
    }
    // pages that add more cards after load (the books wall's "Load more") announce it so they get painted too
    document.addEventListener('rf:cards:added', init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    window.addEventListener('pageshow', function (e) { if (e.persisted) init(); }); // back button
  })();
  } catch(e) { console.error(e); }
})();

})();
